import api from "./api";

export const getUrlParam = key => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(key);
}

export const createUrlParamsFromObject = obj => {
    const params = new URLSearchParams(obj);
    return params.toString();
}

export const getRegionFromUrl = () => {
    let regionId = getUrlParam('region_id') !== 'null' ? getUrlParam('region_id') : null;
    let regionNome = getUrlParam('region_nome') !== 'null' ? getUrlParam('region_nome') : null;
    let regionSlug = getUrlParam('region_slug') !== 'null' ? getUrlParam('region_slug') : null;

    if (regionId && regionNome && regionSlug) {
        return {
            id: regionId,
            nome: regionNome,
            slug: regionSlug
        };
    }

    return {};
};